var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#545565"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13.9999,
    r: 10.1818,
    fill: "#545565"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7029 14.3354H16.6108V13.3063H17.7029C17.867 13.3063 18 13.176 18 13.015C18 12.8541 17.867 12.7237 17.7029 12.7237H16.6108V11.2957C16.6108 11.0873 16.5688 10.9343 16.486 10.8411C16.4073 10.7524 16.3038 10.7112 16.1606 10.7112C16.0238 10.7112 15.9242 10.7522 15.8471 10.8403C15.7652 10.9336 15.7237 11.0868 15.7237 11.2958V12.7239H13.6695L12.796 11.4279C12.7213 11.3122 12.651 11.2039 12.5827 11.0999C12.5213 11.0063 12.4614 10.93 12.4047 10.8731C12.3546 10.8227 12.2975 10.7836 12.2307 10.7537C12.1677 10.7254 12.0875 10.7113 11.9927 10.7113C11.8718 10.7113 11.7621 10.7438 11.6569 10.8105C11.5529 10.8765 11.481 10.9581 11.4371 11.06C11.3986 11.1568 11.3782 11.3052 11.3782 11.4968V12.7238H10.297C10.1329 12.7238 10 12.8542 10 13.0151C10 13.176 10.1329 13.3063 10.297 13.3063H11.3782V14.3356H10.297C10.1329 14.3356 10 14.4659 10 14.6269C10 14.7878 10.1329 14.918 10.297 14.918H11.3782V16.5484C11.3782 16.7507 11.4216 16.9022 11.5074 16.9984C11.5891 17.0902 11.6926 17.1328 11.8332 17.1328C11.9688 17.1328 12.0715 17.09 12.1567 16.998C12.2439 16.9039 12.2881 16.7525 12.2881 16.5484V14.918H14.1469L15.1528 16.4305C15.2227 16.5305 15.295 16.6314 15.367 16.7304C15.432 16.8192 15.5029 16.8975 15.5777 16.9629C15.645 17.022 15.7173 17.0654 15.7923 17.0918C15.8696 17.1191 15.9599 17.1329 16.0602 17.1329C16.3322 17.1329 16.6108 17.0513 16.6108 16.4457V14.918H17.7029C17.867 14.918 18 14.7876 18 14.6267C18 14.4658 17.867 14.3354 17.7029 14.3354ZM15.7237 13.3063V14.3354H14.7558L14.0622 13.3063H15.7237ZM12.2881 12.1237L12.6872 12.7237H12.2881V12.1237ZM12.2881 14.3354V13.3063H13.0748L13.7594 14.3354H12.2881ZM15.7237 15.7718L15.1484 14.918H15.7237V15.7718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7.84442,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.18927652c48e0bd9eda549be4d68f14a.svg";
export { ForwardRef as ReactComponent };